import { CrisisResources } from '../components/CrisisResources';
import { LegalPage } from '../components/LegalPage';

/**
 * Safety Center page. Explains the safety architecture in plain
 * language — the moderation cascade, the crisis path, what to do as a
 * user. Surfaces 988 + Crisis Text Line prominently. The page should
 * be reachable from anywhere in the app via the footer + from the
 * Landing page so a prospective user can read it before signing up.
 */
export function Safety() {
  return (
    <LegalPage title="Safety Center" lastUpdated="2026-05-23">
      <div className="crisis">
        <strong>If you're in crisis right now</strong>
        <CrisisResources />
      </div>

      <h2>What LessAlone is</h2>
      <p>
        LessAlone is a one-to-one text app for adult members of a single community (your campus,
        your workplace, your health plan). It exists to reduce everyday loneliness by giving you a
        real person to talk to. It is <strong>not a crisis service</strong> and we are not
        monitoring conversations in real time.
      </p>

      <h2>How we keep the space safe</h2>
      <ul>
        <li>
          <strong>18+ only.</strong> Age is verified at sign-up. Minors are engineered out — no
          membership can be created without an age check passing.
        </li>
        <li>
          <strong>One-to-one only.</strong> There is no group chat in LessAlone, by design.
        </li>
        <li>
          <strong>Pseudonymous to your peer.</strong> They see the nickname you choose. They never
          see your real name or email.
        </li>
        <li>
          <strong>Every message is checked.</strong> A fast heuristic checks every message as it's
          sent. Anything that looks like harm or off-platform contact is held for moderator review
          before reaching your peer.
        </li>
        <li>
          <strong>Crisis is detect-and-refer.</strong> If our checks see language consistent with
          self-harm, we deliver the message AND immediately surface 988 + Crisis Text Line. A human
          moderator is notified to follow up.
        </li>
        <li>
          <strong>Append-only audit log.</strong> Every moderator action is logged and cannot be
          erased.
        </li>
      </ul>

      <h2>What to do if you don't feel safe</h2>
      <ol>
        <li>
          <strong>Use the ⋯ menu in the chat to Report</strong> — your peer doesn't see the report
          and a moderator will review it.
        </li>
        <li>
          <strong>Block & end the conversation.</strong> Same ⋯ menu. You won't be matched with this
          person again.
        </li>
        <li>
          <strong>For an immediate emergency</strong>, call 911 (or your local equivalent).
        </li>
      </ol>

      <h2>What we promise we won't do</h2>
      <ul>
        <li>We will never reveal your real identity to your peer.</li>
        <li>We will never sell your data.</li>
        <li>We will never use your conversations for advertising.</li>
        <li>We will never tell another member that you reported them.</li>
      </ul>

      <h2>Questions</h2>
      <p>
        Email <a href="mailto:hello@lessalone.app">hello@lessalone.app</a> — we read every one.
      </p>
    </LegalPage>
  );
}
